module.exports = __webpack_public_path__ + "static/4-311e2ea21d8c1dbd3bfae5abaf5a76ac.jpg";